import { Injectable } from '@angular/core';
import { RidangoReduxAction, Company } from '@ridango/core';


@Injectable()
export class CompanyActions {
    static SET_ALL_COMPANIES = '[Companies]: Set All Companies';
    static SET_SELECTED_COMPANY = '[Companies]: Set Selected Company';
    static CLEAR_COMPANIES = '[Companies]: Set All Companies';
    setAllCompanies ( payload: Company[] ): RidangoReduxAction {
        return {
            type: CompanyActions.SET_ALL_COMPANIES,
            payload: payload
        };
    }
    setSelectedCompany ( payload: Company ): RidangoReduxAction {
        return {
            type: CompanyActions.SET_SELECTED_COMPANY,
            payload: payload
        };
    }
    clearCompanies(): RidangoReduxAction {
        return {
            type: CompanyActions.CLEAR_COMPANIES
        };
    }
}
